import React from 'react'
import "./experiencia.css"
import {AiOutlineHtml5} from "react-icons/ai"
import {LiaCss3} from "react-icons/lia"
import {BiLogoSass} from "react-icons/bi"
import {RiJavascriptFill} from "react-icons/ri"
import {FaReact} from "react-icons/fa"


import {FaPython} from "react-icons/fa"
import {FaJava} from "react-icons/fa"
import {BiLogoDjango} from "react-icons/bi"
import {GrMysql} from "react-icons/gr"

const Experiencia = () => {
  return (
    <section id='experiencia'>
      <h5>Mis skills son</h5>
      <h2>mi Experiencia</h2>

      <div className='container experience__container'>
        <div className="experience__frontend">
          <h3>Frontend Developer</h3>
          <div className="experience__content">
            <article>
              <AiOutlineHtml5 className='experience__details-icon'/>
              <div>
                <h4>HTML</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>
            <article>
              <LiaCss3 className='experience__details-icon'/>
              <div>
                <h4>CSS</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>
            <article>
              <BiLogoSass className='experience__details-icon'/>
              <div>
                <h4>SASS</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>
            <article>
              <RiJavascriptFill className='experience__details-icon'/>
              <div>
                <h4>JAVASCRIPT</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>
            <article>
              <FaReact className='experience__details-icon'/>
              <div>
                <h4>REACT JS</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>

          </div>
          
        </div>






        <div className="experience__backend">
        <h3>backend Developer</h3>
          <div className="experience__content">
            <article>
              <FaPython className='experience__details-icon'/>
              <div>
                <h4>PYTHON</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>
            <article>
              <FaJava className='experience__details-icon'/>
              <div>
                <h4>JAVA</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>
            <article>
            
              <BiLogoDjango className='experience__details-icon'/>
              <div>
                <h4>DJANGO</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>
            <article>
              <GrMysql className='experience__details-icon'/>
              <div>
                <h4>MYSQL</h4>
                <small className='text-ligth'>Experiencia</small>
              </div>
            </article>


          </div>

        </div>
      </div>
    </section>
  )
}

export default Experiencia